import React from "react";

import { getAllJobs } from "lib/localContent";

import TeamPhotos from "components/careers/TeamPhotos";

import CareersHeader from "components/careers/CareersHeader";

import ApplicationLayout from "components/ApplicationLayout";
import Navbar from "components/Navbar";
import PageContent from "components/PageContent";
import SharedFooter from "components/SharedFooter";

import Container from "components/Container";

import Legend from "components/careers/Legend";
import OpenPositions from "components/careers/OpenPositions";
import SocialFooter from "components/SocialFooter";
import Investors from "components/careers/Investors";
import HiringProcess from "components/careers/HiringProcess";
import Benefits from "components/careers/Benefits";
import HowWeWork from "components/careers/HowWeWork";
import Team from "components/careers/Team";
import OurValues from "components/careers/OurValues";
import Timeline from "components/careers/Timeline";

import type { Page } from "types/page";
import type { Job } from "lib/localContent";

export const getStaticProps = async () => {
  const jobs = getAllJobs();
  return {
    props: {
      jobs,
    },
  };
};

type PageProps = {
  jobs: Job[];
};

const Careers: Page<PageProps> = ({ jobs }) => {
  return (
    <div style={{ width: "100%" }}>
      <Container>
        <CareersHeader />
        <Timeline />
        <OurValues />
        <Team />
        <HowWeWork />
        <TeamPhotos />
        <Benefits />
        <OpenPositions jobs={jobs} />
        <HiringProcess />
        <Investors />
        <SocialFooter />
      </Container>
    </div>
  );
};

Careers.getLayout = (page) => {
  return (
    <ApplicationLayout>
      <Navbar />
      <Legend />
      <PageContent>{page}</PageContent>
      <SharedFooter />
    </ApplicationLayout>
  );
};

export default Careers;
